export default "__VITE_ASSET__73d33ef5__"